import { IsNumber, IsString } from 'class-validator';

export class DealCodeList {
    @IsNumber()
    id!: number;
    @IsNumber()
    customField!: number;
    @IsString()
    analysisCode!: string;
    @IsString()
    analysisText!: string;
}
